module.exports = __webpack_public_path__ + "static/img/bk-dx.82446b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/qml/img/bk-dx.png
// module id = N4yD
// module chunks = 1